import Chart from 'chart.js';

export default class BubbleChart {
    chart = null;
    datasets = null;

    static initAll() {
        const bubbleCharts = document.querySelectorAll('.bubble-chart');

        if (bubbleCharts.length == 0)
            return;

        bubbleCharts.forEach((bubbleChart) => {
            new BubbleChart(bubbleChart)
        });
    }

    constructor(bubbleChartContainer) {
			if(bubbleChartContainer == null || bubbleChartContainer == undefined)
            return;

        
			this.datasets = JSON.parse(bubbleChartContainer.dataset.datasets);

			this.updateDatasets(bubbleChartContainer.getBoundingClientRect().height);
        
			this.chart = new Chart(bubbleChartContainer.querySelector('canvas'), {
				type: "bubble",
				data: {
					datasets: this.datasets
				},
				options: {
					legend: {
						display: false
					},
					tooltips: {
						enabled: true,
						callbacks: {
							title: function (tooltipItem, data) {
								let datapoint = data.datasets[tooltipItem[0].datasetIndex].data[tooltipItem[0].index];
								return datapoint.percentage + " %";
							},
							label: function (tooltipItem, data) {
								let datapoint = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
								return datapoint.label;
							}
						},
						titleFontSize: 18,
						bodyFontSize: 17,
						backgroundColor: "#FFF",
						titleFontColor: "#003542",
						bodyFontColor: "#003542",
						titleFontFamily: "PoppinsRegular",
						bodyFontFamily: "PoppinsRegular",
						displayColors: false,
						xPadding: 12,
						yPadding: 12,
						caretSize: 10,
						cornerRadius: 0
					},
					scales: {
						xAxes: [{
							ticks: {
								min: 0,
								max: 100,
								display: false
							},
							gridLines: {
								display: false
							}
						}],
						yAxes: [{
							ticks: {
								min: 0,
								max: 100,
								display: false
							},
							gridLines: {
								display: false
							}
						}]
					},
					plugins: {
						deferred: {
							yOffset: "50%", // defer until 50% of the canvas height are inside the viewport
							delay: 200      // delay of 500 ms after the canvas is considered inside the viewport
						}
					}
				}
			});
    }

    updateDatasets(chartHeight) {
			const minRadius = window.innerWidth < 768 ? 12 : 28;
			let radiusMax = 0;

			this.datasets.forEach((dataset) => {
				dataset.data.forEach((data) => {
					radiusMax = Math.max(radiusMax, Number(data.r));
				});
			});

			radiusMax = Math.min(radiusMax, chartHeight / 2 - 30);

			this.datasets.forEach((dataset) => {
				delete dataset.type;
				dataset.data.forEach((data) => {
					data.x = Math.min(Number(data.x), 100);
					data.y = Math.min(Number(data.y), 100);
					data.r = Math.min(Number(data.r), 100);
					data.percentage = Number(JSON.parse(JSON.stringify(data.r)));
					dataset.pointHitRadius = 20;

					data.r = Math.max(data.r / radiusMax * (chartHeight / 2 - 30), minRadius);
				});
			});
    }
}